import React from "react";
import { Link } from "react-router-dom";
import { RariumWordmark } from "./Logo";
import { useLanguage } from "../context/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer className="mt-24 bg-stone-900 text-stone-50 relative overflow-hidden grain">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <RariumWordmark inverted className="h-14 -ml-1" />
          <p className="mt-4 text-stone-400 max-w-md leading-relaxed">
            {t("Aste curate per collezionisti esigenti. Ogni oggetto è verificato dai nostri esperti prima di essere presentato al mercato.")}
          </p>
          <p className="mt-2 text-xs text-stone-500 max-w-md">
            {t("Commissione venditore: ")}<span className="text-[#B49A5F] font-semibold">10%</span>{t(" sul prezzo di aggiudicazione. Nessun costo se il lotto non viene venduto.")}
          </p>
          <Link to="/sell" data-testid="footer-sell-cta" className="mt-8 inline-block text-xs uppercase tracking-widest font-semibold bg-[#8C3A3A] hover:bg-[#7F3434] px-8 py-4 transition-colors">
            {t("Vendi con noi")} →
          </Link>
        </div>
        <div className="md:col-span-2">
          <div className="overline text-stone-500">{t("Marketplace")}</div>
          <ul className="mt-4 space-y-2 text-sm text-stone-300">
            <li><Link to="/browse" className="underline-hover">{t("Tutte le aste")}</Link></li>
            <li><Link to="/categories" className="underline-hover">{t("Categorie")}</Link></li>
            <li><Link to="/sell" className="underline-hover">{t("Vendi")}</Link></li>
          </ul>
        </div>
        <div className="md:col-span-2">
          <div className="overline text-stone-500">{t("Company")}</div>
          <ul className="mt-4 space-y-2 text-sm text-stone-300">
            <li><Link to="/about" className="underline-hover">{t("Il nostro metodo")}</Link></li>
            <li><a href="#" className="underline-hover">{t("Esperti")}</a></li>
            <li><a href="#" className="underline-hover">{t("Stampa")}</a></li>
          </ul>
        </div>
        <div className="md:col-span-3">
          <div className="overline text-stone-500">{t("Contatti")}</div>
          <ul className="mt-4 space-y-2 text-sm text-stone-300">
            <li>info@rariumgroup.it</li>
            <li>+39 331 8675514</li>
            <li>Via Rialto Ferrovia 51, Formia</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-stone-800">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row justify-between text-xs text-stone-500 gap-2">
          <div>© {new Date().getFullYear()} Rarium — Curated Auctions</div>
          <div className="flex gap-6"><a href="#" className="underline-hover">{t("Privacy")}</a><a href="#" className="underline-hover">{t("Termini")}</a><button type="button" onClick={() => window.dispatchEvent(new Event("rarium:open-cookie-settings"))} className="underline-hover" data-testid="footer-cookie-settings-btn">{t("Cookie")}</button></div>
        </div>
      </div>
    </footer>
  );
}
